module.exports = __webpack_public_path__ + "static/media/lv.8b293d98.svg";